// src/services/instances.service.js
import { http } from "./http";

const API_URL = process.env.REACT_APP_API_URL;

/** POST /api/instances/send/{questionnaireId} */
export async function sendInstance(questionnaireId, payload) {
  const { data } = await http.post(
    `${API_URL}/api/instances/send/${questionnaireId}`,
    payload
  );
  return data; // QuestionnaireInstanceDto
}

/** DELETE /api/instances/cancel/{processInstanceId} */
export async function cancelInstance(processInstanceId) {
  const res = await http.delete(
    `${API_URL}/api/instances/cancel/${processInstanceId}`
  );
  return res.status === 204 ? null : res.data;
}

/** GET /api/instances/{processInstanceId} */
export async function getInstance(processInstanceId) {
  const { data } = await http.get(
    `${API_URL}/api/instances/${processInstanceId}`
  );
  return data; // QuestionnaireInstanceAnswersDto
}

/** GET /api/instances/{processInstanceId}/{userId} */
export async function getUserAnswers(processInstanceId, userId) {
  const { data } = await http.get(
    `${API_URL}/api/instances/${processInstanceId}/${userId}`
  );
  return data; // UserAnswerDto
}

/** 
 * GET /api/process-instances/my-assignments
 * Devuelve la lista de MyAssignmentRowDto para el usuario logueado
 */
export async function getMyAssignments() {
  const started = Date.now();
  const { data } = await http.get(
    `${API_URL}/api/instances/my-assignments`
  );
  const received = Date.now();
  return (data || []).map(row => ({ ...row,
    clockOffset: row.serverNow ? Date.parse(row.serverNow) - (started + received) / 2 : 0,
  }));
}

export async function getAdminTasksForProcessInstance(processInstanceId) {
  const { data } = await http.get(
    `${API_URL}/api/instances/admin/tasks/${processInstanceId}`
  );
  return data;
}
